import { render, staticRenderFns } from "./root.vue?vue&type=template&id=4d45d1c5&lang=pug&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d45d1c5')) {
      api.createRecord('4d45d1c5', component.options)
    } else {
      api.reload('4d45d1c5', component.options)
    }
    module.hot.accept("./root.vue?vue&type=template&id=4d45d1c5&lang=pug&", function () {
      api.rerender('4d45d1c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autoservice/root.vue"
export default component.exports